export default __webpack_public_path__ + "static/media/transmitOfff.159636dd.svg";